<ng-template>
    <ng-content></ng-content>
</ng-template>

@switch (kind) {
    @case (SubmissionBarKind.DrawerBasic) {
        <div [ngClass]="{ 'sb-drawer-submission-bar': !isMobile, 'sb-drawer-submission-bar-mobile': isMobile }">
            @if (isMobile) {
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (tertiaryButton) {
                        <ng-container *ngTemplateOutlet="tertiaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            } @else {
                <lib-button-group>
                    @if (tertiaryButton) {
                        <ng-container *ngTemplateOutlet="tertiaryButtonRef"></ng-container>
                    }
                </lib-button-group>

                <lib-button-group>
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            }
        </div>
    }
    @case (SubmissionBarKind.DrawerWizard) {
        <div [ngClass]="{ 'sb-drawer-submission-bar': !isMobile, 'sb-drawer-submission-bar-mobile': isMobile }">
            @if (isMobile) {
                <lib-button-group [stretch]="true">
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }

                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (tertiaryButton) {
                        <ng-container *ngTemplateOutlet="tertiaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            } @else {
                <lib-button-group>
                    @if (tertiaryButton) {
                        <ng-container *ngTemplateOutlet="tertiaryButtonRef"></ng-container>
                    }
                </lib-button-group>

                <lib-button-group>
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            }
        </div>
    }
    @case (SubmissionBarKind.DialogBasic) {
        <div [ngClass]="{ 'sb-dialog-submission-bar': !isMobile, 'sb-dialog-submission-bar-mobile': isMobile }">
            @if (isMobile) {
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (tertiaryButton) {
                        <ng-container *ngTemplateOutlet="tertiaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            } @else {
                <lib-button-group>
                    @if (tertiaryButton) {
                        <ng-container *ngTemplateOutlet="tertiaryButtonRef"></ng-container>
                    }
                </lib-button-group>

                <lib-button-group>
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            }
        </div>
    }
    @case (SubmissionBarKind.DialogDanger) {
        <div [ngClass]="{ 'sb-dialog-submission-bar': !isMobile, 'sb-dialog-submission-bar-mobile': isMobile }">
            @if (isMobile) {
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (tertiaryButton) {
                        <ng-container *ngTemplateOutlet="tertiaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            } @else {
                <lib-button-group>
                    @if (tertiaryButton) {
                        <ng-container *ngTemplateOutlet="tertiaryButtonRef"></ng-container>
                    }
                </lib-button-group>

                <lib-button-group>
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            }
        </div>
    }
    @case (SubmissionBarKind.DrawerAttendance) {
        <div [ngClass]="{ 'sb-drawer-submission-bar': !isMobile, 'sb-drawer-submission-bar-mobile': isMobile }">
            @if (isMobile) {
                <div class="sb-drawer-submission-bar-iterator">
                    <lib-button-group [orientation]="Orientation.Vertical">
                        @if (primaryButton) {
                            <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                        }
                    </lib-button-group>
                    @if (customActionRef) {
                        <ng-container *ngTemplateOutlet="customActionRef"></ng-container>
                    }
                </div>
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            } @else {
                @if (customActionRef) {
                    <ng-container *ngTemplateOutlet="customActionRef"></ng-container>
                }

                <lib-button-group>
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            }
        </div>
    }
    @case (SubmissionBarKind.WidgetBasic) {
        <div [ngClass]="{ 'sb-widget-submission-bar': !isMobile, 'sb-widget-submission-bar-mobile': isMobile }">
            @if (isMobile) {
                <lib-button-group [orientation]="Orientation.Vertical">
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            } @else {
                <div class="sb-widget-submission-bar-min-width">
                    <lib-button-group [stretch]="true">
                        @if (secondaryButton) {
                            <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                        }
                        @if (primaryButton) {
                            <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                        }
                    </lib-button-group>
                </div>
            }
        </div>
    }
    @case (SubmissionBarKind.WidgetStepper) {
        <div [ngClass]="{ 
            'sb-widget-submission-bar-stepper': !isMobile, 
            'sb-widget-submission-bar-mobile': isMobile || !primaryButton }">
            @if (isMobile || !primaryButton) {
                @if (customActionRef) {
                    <ng-container *ngTemplateOutlet="customActionRef"></ng-container>
                }
                <lib-button-group [stretch]="true">
                    @if (secondaryButton) {
                        <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                    }
                    @if (primaryButton) {
                        <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                    }
                </lib-button-group>
            } @else {
                @if (secondaryButton) {
                    <ng-container *ngTemplateOutlet="secondaryButtonRef"></ng-container>
                }
                <div class="sb-widget-submission-bar-stepper-custom-action">
                    @if (customActionRef) {
                        <ng-container *ngTemplateOutlet="customActionRef"></ng-container>
                    }
                </div>
                @if (primaryButton) {
                    <ng-container *ngTemplateOutlet="primaryButtonRef"></ng-container>
                }
            }
        </div>
    }
}

<ng-template #primaryButtonRef>
    <lib-button
        #newPrimaryButton
        [kind]="kind === SubmissionBarKind.DialogDanger ? ButtonKind.Danger : primaryButton!.kind"
        [disabled]="primaryButton!.disabled"
        [loading]="primaryButton!.loading"
        [isViewOnly]="primaryButton!.isViewOnly"
        [size]="ButtonSize.Large"
        [prefixIcon]="primaryButton!.prefixIcon"
        [suffixIcon]="primaryButton!.suffixIcon"
        [role]="primaryButton!.role"
        [stretch]="true"
        [qaTag]="primaryButton!.qaTag"
        (pressed)="primaryButton!.pressed.emit()"
        (clicked)="primaryButton!.clicked.emit()">
        <ng-container label>{{ primaryButton!.buttonLabel?.nativeElement!.textContent }}</ng-container>
    </lib-button>
</ng-template>

<ng-template #secondaryButtonRef>
    <lib-button
        #newSecondaryButton
        [kind]="
            isMobile && kind !== SubmissionBarKind.WidgetStepper
                ? ButtonKind.NeutralTertiary
                : ButtonKind.NeutralSecondary
        "
        [disabled]="secondaryButton!.disabled"
        [loading]="secondaryButton!.loading"
        [isViewOnly]="secondaryButton!.isViewOnly"
        [size]="ButtonSize.Large"
        [prefixIcon]="secondaryButton!.prefixIcon"
        [suffixIcon]="secondaryButton!.suffixIcon"
        [role]="secondaryButton!.role"
        [stretch]="true"
        [qaTag]="secondaryButton!.qaTag"
        (pressed)="secondaryButton!.pressed.emit()"
        (clicked)="secondaryButton!.clicked.emit()">
        <ng-container label>{{ secondaryButton!.buttonLabel?.nativeElement!.textContent }}</ng-container>
    </lib-button>
</ng-template>

<ng-template #tertiaryButtonRef>
    <lib-button
        #newTertiaryButton
        [kind]="tertiaryButton!.kind"
        [disabled]="tertiaryButton!.disabled"
        [loading]="tertiaryButton!.loading"
        [isViewOnly]="tertiaryButton!.isViewOnly"
        [size]="ButtonSize.Large"
        [prefixIcon]="tertiaryButton!.prefixIcon"
        [suffixIcon]="tertiaryButton!.suffixIcon"
        [role]="tertiaryButton!.role"
        [stretch]="true"
        [qaTag]="tertiaryButton!.qaTag"
        (pressed)="tertiaryButton!.pressed.emit()"
        (clicked)="tertiaryButton!.clicked.emit()">
        <ng-container label>{{ tertiaryButton!.buttonLabel?.nativeElement!.textContent }}</ng-container>
    </lib-button>
</ng-template>
